export const panelStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '24px',
  borderRadius: ({ shape }) => shape.radius.s,
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: ({ palette }) => palette.shadow.m,
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const readyIconStyles = {
  color: ({ palette }) => palette.success.main,
  display: 'flex',
};

export const missingIconStyles = {
  color: ({ palette }) => palette.warning.main,
  display: 'flex',
};

export const categoryGroupStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
};

export const categoryListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const itemRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 12px',
  borderRadius: ({ shape }) => shape.radius.s,
  backgroundColor: ({ palette }) => palette.action.hover,
};

export const itemDotStyles = {
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: ({ palette }) => palette.warning.main,
};
